import { render } from "./SuspendDepotModal.vue?vue&type=template&id=1ce9a1bc"
import script from "./SuspendDepotModal.vue?vue&type=script&lang=js"
export * from "./SuspendDepotModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__